import { Component } from '@angular/core';
import { GraphqlService } from 'src/app/graphql/graphql.service';
import { WebSupplierMetrics } from '../../models';
import { AbstractPageForm } from '../../pages/page-form.abstract';

@Component({
    selector: 'pk-web-supplier-carousel',
    templateUrl: './supplier-carousel.component.html',
    styleUrl: './supplier-carousel.component.scss',
    standalone: false
})
export class SupplierCarouselComponent extends AbstractPageForm {
	public webSupplierMetricsGroups: WebSupplierMetrics[][];
	public webSupplierMetrics: WebSupplierMetrics[];

	constructor(private graphqlService: GraphqlService) {
		super();
	}

	public override async loadPageData(): Promise<void> {
		const result = await this.graphqlService.query<{
			webSupplierMetrics: WebSupplierMetrics[];
		}>(`
			query GetWebSupplierMetrics {
				webSupplierMetrics {
					name
					logo
				}
			}
		`);

		this.webSupplierMetricsGroups = [];
		this.webSupplierMetrics = result.data.webSupplierMetrics.map(m => new WebSupplierMetrics(m));

		for (let i = 0; i < this.webSupplierMetrics.length; i++) {
			const slide = this.webSupplierMetrics.slice(i, i + 4);
			if (slide.length < 4) {
				// make sure the end of the slides wrap around to the beginning
				slide.push(...this.webSupplierMetrics.slice(0, 4 - slide.length));
			}
			this.webSupplierMetricsGroups.push(slide);
		}
	}
}
